export const getPointPropertiesFromSchemaEvent = event => {
  const eventPosition = event.eventDetails.position;

  return {
    heading: eventPosition.heading.value,
    altitude: eventPosition.altitudeMeanSeaLevel?.value,
    speed: eventPosition.groundSpeed.value
  };
};
